import React from "react";
import "./Premium.css";
import CardImg from "../Cards/CardsImg";
import card_img1 from "../../Images/Nearby/kaasPhool.jpg";
import card_img2 from "../../Images/Nearby/dorabjiTataPark.jpg";
import card_img3 from "../../Images/Nearby/againJubilee.jpg";
import card_img4 from "../../Images/Nearby/chandilDam.jpg";
import card_img5 from "../../Images/Nearby/natureTrail.jpg";
import card_img6 from "../../Images/Nearby/rivers.jpg";
function Premium() {
  return (
    <div className="premium-container">
      <p style={{ fontFamily: "Playfair Display" }} className="premium">
        Premium Facilities
      </p>
      <div className="premium-container-first">
        <p className="premium-container-title">Exclusive Premium Facilties</p>
        <p className="premium-container-about">
        Nestled in the lush greenery of Kandra, surrounded by the serene wilderness of nearby forests, our resort offers a peaceful retreat away from the bustle of Jamshedpur. Guests can enjoy a comfortable, happy stay, immersed in nature's tranquility.
        </p>
      </div>
      <div className="card-container upper-card">
        <CardImg
          image={card_img1}
          heading="Discover Nature's Beauty"
          detail="Embark on scenic road trips to explore the stunning Kaas Phool landscapes"
        />
        <CardImg
          image={card_img2}
          heading="Relax Amidst Beauty"
          detail="Take a short trip to Dorabji Tata Park and enjoy its stunning architecture and vibrant flower-filled gardens"
        />
        <CardImg
          image={card_img3}
          heading="Adventure and Serenity Combined"
          detail="Visit Jubilee Park to explore its beautiful architecture, Jayanti Sarovar, the zoological park, lush green landscapes, and a fun-filled amusement park"
        />
      </div>
      <div className="card-container lower-card">
        <CardImg
          image={card_img4}
          heading="Majestic Waters Await"
          detail="Discover the majestic Chandil Dam, surrounded by mountains with a serene island at its center, perfect for a peaceful getaway"
        />
        <CardImg
          image={card_img5}
          heading="Walk in Nature's Bliss"
          detail="Stroll along the Nature Trail by Marine Drive, a serene park filled with trees, bushes, and blooming flowers"
        />
        <CardImg
          image={card_img6}
          heading="Refresh by the Rivers"
          detail="Unwind by the picturesque Kharkai and Domuhani rivers, where breathtaking views wash away all your stress"
        />
      </div>
    </div>
  );
}

export default Premium;
